import config from './config/text.js';
import create from './create/text.js';
import coneCrusher from './details/coneCrusher/texts.js';
import crusherConfiguration from './details/CrusherConfiguration/texts.js';
import hammer from './details/hammer/texts.js';
import screen from './details/screen/texts.js';

export default {
  create,
  config,
  header: {
    notes: 'Header when listing equipment',
    message: 'Equipment',
  },
  generalinformation: {
    header: {
      notes: 'Header in general information section',
      message: 'General information',
    },
  },
  settings: {
    header: {
      notes: 'Settings section',
      message: 'Settings',
    },
    confirmTripMeterResetDialog: {
      title: {
        notes: 'Trip meter reset dialog title',
        message: 'Reset trip meter',
      },
      content: {
        notes: 'Dialog main content text',
        message: 'Are you sure you want to reset the work hours trip meter?',
      },
    },
    model: {
      tripMeterResetDate: {
        notes: 'Trip meter reset date title',
        message: 'Trip meter reset date',
      },
      tripMeter: {
        notes: 'Trip meter title',
        message: 'Work hours trip meter',
      },
      workingHoursCalibration: {
        notes: 'Working hours calibration title',
        message: 'Working hours calibration',
      },
      impactHoursCalibration: {
        notes: 'Impact hours calibration title',
        message: 'Impact hours calibration',
      },
      serviceInterval: {
        notes: 'Service interval title',
        message: 'Service interval default',
      },
      serviceIntervalOverride: {
        notes: 'Service interval override title',
        message: 'Service interval override',
      },
      reportingTime: {
        notes: 'Reporting time title',
        message: 'Reporting time default',
      },
      reportingTimeOverride: {
        notes: 'Reporting time override title',
        message: 'Reporting time override',
      },
      timeZoneDetected: {
        notes: 'Time zone detected title',
        message: 'Time zone detected',
      },
      timeZoneOverride: {
        notes: 'Time zone override title',
        message: 'Time zone override',
      },
      bluetoothEnabled: {
        notes: 'Bluetooth enabled title',
        message: 'Bluetooth',
        enabled: {
          notes: 'Bluetooth enabled value',
          message: 'Enabled',
        },
        disabled: {
          notes: 'Bluetooth disabled value',
          message: 'Disabled',
        },
      },
    },
  },
  crusherConfiguration,
  coneCrusher,
  hammer,
  screen,
  action: {
    addSandvikEquipment: {
      notes: 'Add Sandvik equipment action',
      message: 'Sandvik equipment',
    },
    addStationaryEquipment: {
      notes: 'Add Sandvik Stationary equipment action',
      message: 'Sandvik Equipment (Stationary)',
    },
    addAtdEquipment: {
      notes: 'Add Sandvik ATD (attachment tools) equipment action',
      message: 'Sandvik equipment (Attachment)',
    },
    addScreenEquipment: {
      notes: 'Add screen action',
      message: 'Screen',
    },
    add3rdPartyEquipment: {
      notes: 'Add 3rd party equipment action',
      message: '3rd party equipment',
    },
    updateOwner: {
      notes: 'Update owner (sell) an equipment to another account/company',
      message: 'Update owner',
    },
    updateOwnerSuccess: {
      notes: 'Update owner was performed successfully',
      message: 'Owner of equipment was successfully updated',
    },
    rentOut: {
      notes: 'Rent out equipment',
      message: 'Rent out',
    },
    rentOutSuccess: {
      notes: 'Rent out equipment was performed successfully',
      message: 'Rent out equipment was performed successfully',
    },
    returnEquipment: {
      notes: 'Return equipment after being rented out',
      message: 'Return equipment',
    },
    returnEquipmentConfirm: {
      notes:
        'Text in body of confirm dialog for returning equipment after rent out',
      message: 'Please confirm the equipment has been returned.',
    },
    dataPrivacyNote: {
      header: {
        notes: 'Text in the header for data privacy accordion',
        message: 'A note on data privacy',
      },
      description: {
        notes:
          'Text in the accordion regarding data privacy when renting out or returning equipment to dealer',
        message:
          'Please note that the new owner will only be able to see the Total Work and Impact hours for the Hydraulic Hammer. All other historical equipment data will be hidden from them, including sensitive information like equipment location history.',
      },
    },
  },
  error: {
    saveRd3Error: {
      notes: 'Error message when unable to save RD3 data',
      message: 'Failed to save RD3 serial number.',
    },
  },
  permits: {
    equipmentUnavailable: {
      notes: 'Empty state text when fetching equipment failed',
      message:
        'The equipment does not exist, or you do not have access to view it.',
    },
  },
};
